define('views/content/reports/distributor_stocks',['require','backbone','marionette','datatables','text!templates/content/reports/distributor_stocks.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');

    var temp = require("text!templates/content/reports/distributor_stocks.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'distributor_stocks',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                distributorStocksTable: '.distributor-stocks-list'
            };
        },

        onRender: function () {
            this.getReports();
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/distributor-stock-reports/',
                method: 'get',
                success: function (response) {
                    _this.showDistributorStockReports(response.distributor_stock_report);
                }
            });
        },

        showDistributorStockReports: function (reportData) {
            // Transform report data for datatables format
            var gridColumns = [
                { title: App.polyglot.t('distributor') },
                { title: App.polyglot.t('days_since_last_purchase'), className: 'text-right' }
            ];

            var totalRow = {};
            var products = reportData[0].products;

            products.forEach(function (product) {
                gridColumns.push({title: product.name, className: 'text-right'});
                totalRow[product.id] = 0;
            });

            var gridData = [];
            reportData.forEach(function (reportRow) {
                var rowData = [
                    reportRow.distributor.name ,
                    reportRow.last_purchase_days
                ];

                reportRow.products.forEach(function (product) {
                   rowData.push(product.count);

                   totalRow[product.id] += product.count;
                });

                gridData.push(rowData);
            });

            // Add total row
            var totalRowData = [
                App.polyglot.t('total'),
                ''
            ];

            products.forEach(function (product) {
               totalRowData.push(totalRow[product.id]);
            });
            gridData.push(totalRowData);

            if (!this.distributorStocksDataTable) {
                this.distributorStocksDataTable = this.ui.distributorStocksTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    fixedHeader: true,
                    scrollY: App.utils.getContainerHeightWOffset(this.ui.distributorStocksTable),
                    columns: gridColumns,
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.distributorStocksDataTable.clear();
                this.distributorStocksDataTable.rows.add(gridData);
                this.distributorStocksDataTable.columns.adjust().draw();
            }
        }

    });
});
